<template>
  <div class="d-flex flex-wrap align-items-end gap-3 mb-3">
    <div>
      <label class="form-label text-muted mb-1" style="font-size: 0.75rem">Período</label>
      <select
        class="form-select form-select-sm"
        v-model="localPeriod"
        @change="onPeriodChange"
      >
        <option v-for="opt in PERIOD_OPTIONS" :key="opt.id" :value="opt.id">
          {{ opt.label }}
        </option>
      </select>
    </div>
    <template v-if="localPeriod === 'custom'">
      <div>
        <label class="form-label text-muted mb-1" style="font-size: 0.75rem">De</label>
        <input
          type="date"
          class="form-control form-control-sm"
          v-model="localFrom"
          @change="emitChange"
        />
      </div>
      <div>
        <label class="form-label text-muted mb-1" style="font-size: 0.75rem">Até</label>
        <input
          type="date"
          class="form-control form-control-sm"
          v-model="localTo"
          @change="emitChange"
        />
      </div>
    </template>
    <small v-if="appliedLabel" class="text-muted mb-1">
      <i class="fa-solid fa-calendar-check me-1"></i>{{ appliedLabel }}
    </small>
    <span
      v-if="loading"
      class="spinner-border spinner-border-sm text-muted mb-1"
    ></span>
  </div>
</template>

<script>
import { PERIOD_OPTIONS } from "@/utils/dashboardCharts";

export default {
  name: "DashPeriodFilter",
  props: {
    period: { type: String, default: "last_12_months" },
    from: { type: String, default: "" },
    to: { type: String, default: "" },
    // {period, from, to} — o recorte que a API devolveu de fato, não o que foi mandado
    applied: { type: Object, default: null },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      PERIOD_OPTIONS,
      localPeriod: this.period,
      localFrom: this.from,
      localTo: this.to,
    };
  },
  computed: {
    appliedLabel() {
      if (!this.applied?.from || !this.applied?.to) return null;
      const f = this.$moment(this.applied.from).format("DD/MM/YYYY");
      const t = this.$moment(this.applied.to).format("DD/MM/YYYY");
      return `Aplicado: ${f} – ${t}`;
    },
  },
  methods: {
    onPeriodChange() {
      // Ao virar "custom" espera o admin preencher De/Até antes de buscar de novo
      if (this.localPeriod !== "custom") this.emitChange();
    },
    emitChange() {
      if (this.localPeriod === "custom" && (!this.localFrom || !this.localTo)) return;
      this.$emit("change", {
        period: this.localPeriod,
        from: this.localPeriod === "custom" ? this.localFrom : undefined,
        to: this.localPeriod === "custom" ? this.localTo : undefined,
      });
    },
  },
};
</script>
